<div class="map-picker-dialog">

    <div class="map-picker-header">
        <h2 mat-dialog-title>{{ data?.title || (mode === 'search' ? 'Seleccionar ubicación' : 'Ubicación') }}</h2>
        <button mat-icon-button (click)="cancel()" matTooltip="Cerrar" tabindex="-1">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="map-picker-toolbar" *ngIf="mode === 'search'">
        <mat-form-field appearance="outline" class="search-field">
            <mat-label>Buscar dirección</mat-label>
            <input matInput #searchInput [(ngModel)]="searchQuery" placeholder="Ej: Av. El Sol 123, Puno"
                (keydown.enter)="geocodeAddress()" />
            <button mat-icon-button matSuffix (click)="geocodeAddress()" matTooltip="Buscar">
                <mat-icon>search</mat-icon>
            </button>
        </mat-form-field>

        <mat-form-field appearance="outline" class="coord-field">
            <mat-label>Latitud</mat-label>
            <input matInput type="number" step="any" [(ngModel)]="latInput" (change)="onManualCoordsChange()" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="coord-field">
            <mat-label>Longitud</mat-label>
            <input matInput type="number" step="any" [(ngModel)]="lngInput" (change)="onManualCoordsChange()" />
        </mat-form-field>
    </div>

    <div class="map-picker-body" [class.split]="showStreetView">
        <div class="map-container">
            <google-map #map height="100%" width="100%" [center]="center" [zoom]="zoom" [options]="mapOptions"
                (mapClick)="onMapClick($event)">
                <map-marker *ngIf="markerPosition" [position]="markerPosition" [options]="markerOptions"
                    (mapDragend)="onMarkerDragEnd($event)"></map-marker>
            </google-map>
        </div>

        <div class="street-view-container" *ngIf="showStreetView" #streetViewContainer></div>
    </div>

    <div class="map-picker-footer">
        <div class="address-preview" *ngIf="address" [matTooltip]="address">
            <mat-icon>place</mat-icon>
            <span>{{ address }}</span>
        </div>
        <div class="address-preview" *ngIf="!address && markerPosition">
            <mat-icon>place</mat-icon>
            <span>{{ markerPosition.lat | number:'1.6-6' }}, {{ markerPosition.lng | number:'1.6-6' }}</span>
        </div>

        <div class="footer-actions">
            <mat-slide-toggle [(ngModel)]="showStreetView" (change)="onToggleStreetView()">
                Street View
            </mat-slide-toggle>
            <button mat-button (click)="cancel()">Cancelar</button>
            <button mat-flat-button color="primary" [disabled]="!markerPosition" (click)="accept()">
                Aceptar
            </button>
        </div>
    </div>

</div>